import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, Modifier } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./RichTextEditor.css"
import '../../App.css'

const RichTextEditor = ({ editorState, setEditorState }) => {

    const onEditorStateChange = (newState) => {
        setEditorState(newState);
    };

    const handleReturn = (e) => {
        const currentContent = editorState.getCurrentContent();
        const selection = editorState.getSelection();
        const newContent = Modifier.insertText(currentContent, selection, '\n');
        const newEditorState = EditorState.push(editorState, newContent, 'insert-characters');
        setEditorState(newEditorState);
        return 'handled';
    };

    return (
        <div className="editor-container" style={{ maxWidth: '100%', overflowY: 'auto',height:'90%' }}>
            <Editor
                editorState={editorState}
                onEditorStateChange={onEditorStateChange}
                handleReturn={handleReturn}
                toolbar={{
                    options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'link', 'history'],
                    inline: {
                        options: ['bold', 'italic', 'underline', 'strikethrough'],
                    },
                    blockType: {
                        inDropdown: true,
                    },
                    fontSize: {
                        options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 36],
                    },
                    fontFamily: {
                        options: ['Arial', 'Georgia', 'Times New Roman', 'Verdana'],
                    },
                }}
                toolbarClassName="toolbar"
                wrapperClassName="wrapper"
                editorClassName="editor"
            />
        </div>
    );
};

export default RichTextEditor;
